export enum DriverRatedTypes {
  Rated = 'Rated',
  Excluded = 'Excluded',
  NonRated = 'NonRated',
  NeverLicensed = 'NeverLicensed',
  Unknown = 'Unknown',
}
